import { render, staticRenderFns } from "./npc-group.vue?vue&type=template&id=646d2910&scoped=true&"
import script from "./npc-group.vue?vue&type=script&lang=js&"
export * from "./npc-group.vue?vue&type=script&lang=js&"
import style0 from "./npc-group.vue?vue&type=style&index=0&id=646d2910&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646d2910",
  null
  
)

export default component.exports